<template>
  <v-app>

    <v-snackbar
      v-for="toast in toasts"
      :key="toast.id"
      v-model="toast.visible"
      :color="toast.type"
      location="top right"
      :timeout="toast.notifyTime"
      variant="flat"
      @timeout="toastStore.removeNotification(toast)"
    >
      {{ toast.message }}

      <v-progress-linear
        absolute
        bottom
        color="white"
        height="2"
        :model-value="toast.progress"
      />

      <template #actions>
        <v-btn text @click="toastStore.removeNotification(toast)">
          <v-icon icon="mdi-close" />
        </v-btn>
      </template>
    </v-snackbar>

    <template v-if="isAuthenticated">
      <the-app-bar-and-nav />
      <v-main class="d-flex flex-column">
        <router-view class="flex-grow-1" />
        <div class="app-version text-caption font-italic font-weight-thin">
          Version {{ getProjectConfig().VITE_APP_VERSION }}, made with ❤️
        </div>
      </v-main>
    </template>

    <LoginView v-else />

  </v-app>
</template>

<script lang="ts" setup>
  import { storeToRefs } from 'pinia'
  import { computed, onMounted } from 'vue'
  import TheAppBarAndNav from '@/components/TheAppBarAndNav.vue'
  import { getProjectConfig } from '@/shared/projectEnvVariables.ts'
  import { useAuthStore } from '@/stores/auth.ts'
  import { useToastStore } from '@/stores/toast.store.ts'
  import LoginView from '@/views/LoginView.vue'

  const authStore = useAuthStore()
  const isAuthenticated = computed(() => authStore.isAuthenticated)

  const toastStore = useToastStore()
  const { toasts } = storeToRefs(toastStore)

  onMounted(() => {
    authStore.retrieveUser()
  })

</script>

<style scoped>
.app-version {
  text-align: right;
  padding: 8px 12px;
  opacity: 0.6;
  flex-shrink: 0;
}
</style>
